// removed by extract-text-webpack-plugin
module.exports = {"main":"BrokerPage-main","spinner":"BrokerPage-spinner","linkWrap":"BrokerPage-linkWrap","link":"BrokerPage-link","header":"BrokerPage-header","headerMain":"BrokerPage-headerMain","dotPart":"BrokerPage-dotPart","descName":"BrokerPage-descName","addressBlock":"BrokerPage-addressBlock","loadsHeader":"BrokerPage-loadsHeader"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BrokerPage/index.css
// module id = 1704
// module chunks = 0